module.exports = __webpack_public_path__ + "img/facts_1950.dd9be5fe.jpg";